<div class="mb-3">
  <div class="d-flex align-items-center justify-content-between mb-2">
    <div class="d-flex align-items-center">
      <label class="form-label small fw-semibold mb-0">{{ label }}</label>
      <i *ngIf="helpText" class="bi bi-info-circle text-muted ms-2" [ngbTooltip]="helpText" container="body"></i>
    </div>
    <button type="button" class="btn btn-sm btn-link p-0 text-primary" (click)="addRow()">
      <i class="bi bi-plus-lg me-1"></i>Add Time Range
    </button>
  </div>

  <div *ngIf="rows.length" class="bg-light rounded-3 p-2">
    <div *ngFor="let row of rows; let i = index" class="d-flex flex-wrap align-items-end gap-2 p-2 mb-2 bg-white rounded-3 border">
      <div *ngFor="let col of columns" style="min-width: 130px;">
        <label class="form-label text-muted mb-1" style="font-size:.7rem">{{ col.label }}</label>

        <input *ngIf="col.type === 'duration'" type="text" class="form-control form-control-sm" placeholder="HH:MM"
          [(ngModel)]="row[col.key]" (ngModelChange)="emitChange()">

        <select *ngIf="col.type === 'select'" class="form-select form-select-sm"
          [(ngModel)]="row[col.key]" (ngModelChange)="emitChange()">
          <option *ngFor="let opt of col.options" [value]="opt">{{ opt }}</option>
        </select>

        <input *ngIf="col.type !== 'duration' && col.type !== 'select'" type="text" class="form-control form-control-sm"
          [(ngModel)]="row[col.key]" (ngModelChange)="emitChange()">
      </div>

      <button type="button" class="btn btn-sm btn-link text-danger p-0 mb-1" title="Remove row" (click)="removeRow(i)">
        <i class="bi bi-trash"></i>
      </button>
    </div>
  </div>
</div>
